export const environment = {
    production: false,
    logLevel: 'INFO',
    settings:
    {
        authUrl: "https://portalserver-qa.acimobills.com/auth/api",
        portalUrl: "https://portalserver-qa.acimobills.com/portal/api",
        regions: [
            {"region": "qa", "baseUrl": "https://qa.walletron.com/Walletron/api"},
        ]
    }
};